import React, { useState, useEffect } from 'react';

import { Link } from "react-router-dom";
import {
    collection,
    addDoc,
    updateDoc,
    deleteDoc,
    query,
    doc,
    orderBy,
    getDocs,
    onSnapshot,
    Timestamp
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import db, { storage } from "./Firebase";

function CardManager() {
    const [cards, setCards] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        category: 'diy_post',
        paid: false,
        status: '1',
        image_url: ''
    });
    const [imageFile, setImageFile] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [editCardId, setEditCardId] = useState(null);
    const [isUploading, setIsUploading] = useState(false);


    useEffect(() => {
        const cardsRef = collection(db, 'nv_cards');
        const q = query(cardsRef, orderBy('created_date', 'desc'));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const cardsData = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setCards(cardsData);
        }, (error) => {
            console.error("Error listening to cards:", error);
        });

        // Cleanup listener on unmount
        return () => unsubscribe();
    }, []);

    const handleChange = e => {
        const { name, value } = e.target;
        let processedValue = value;

        if (name === 'paid') {
            processedValue = value === 'true';
        }

        setFormData(prev => ({
            ...prev,
            [name]: processedValue
        }));
    };

    const handleImageChange = e => {
        if (e.target.files[0]) {
            setImageFile(e.target.files[0]);
        }
    };
    const handleSubmit = async e => {
        e.preventDefault();
        setIsUploading(true);

        try {
            let imageUrl = formData.image_url;

            if (imageFile) {
                const storageRef = ref(storage, `images/${imageFile.name}`);
                await uploadBytes(storageRef, imageFile);
                imageUrl = await getDownloadURL(storageRef);
            }

            const cardData = {
                name: formData.name,
                category: formData.category,
                paid: formData.paid,
                status: formData.status,
                image_url: imageUrl,
                created_date: Timestamp.now()
            };

            if (isEditing) {
                await updateDoc(doc(db, 'nv_cards', editCardId), cardData);
            } else {
                await addDoc(collection(db, 'nv_cards'), cardData);
            }

            setFormData({
                name: '',
                category: 'diy_post',
                paid: false,
                status: '1',
                image_url: ''
            });
            setImageFile(null);
            setIsEditing(false);
            setEditCardId(null);
        } catch (error) {
            console.error('Error saving card:', error);
        } finally {
            setIsUploading(false);
        }
    };


    const handleEdit = card => {
        setFormData({
            name: card.name,
            category: card.category,
            paid: card.paid,
            status: card.status,
            image_url: card.image_url
        });
        setIsEditing(true);
        setEditCardId(card.id);
    };

    const handleDelete = async id => {
        try {
            await deleteDoc(doc(db, 'nv_cards', id));

        } catch (error) {
            console.error('Error deleting card:', error);
        }
    };

    return (
        <>
            <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
                <div className="p-2" style={{ textAlign: "start", paddingBottom: "5px" }}>
                    <Link to="/">
                        <img src="/images/menubutton.png" className="menu-toggle" alt="Responsive" style={{ height: "2rem" }} />
                    </Link>
                </div>
                <div className="p-2">
                    <div class="w3layouts_payment_online_form" style={{ textAlign: "start", paddingBottom: "5px" }}>
                        {/* <h2>{isEditing ? 'Edit Card' : 'Add New Card'}</h2> */}
                        <form onSubmit={handleSubmit} style={{ marginBottom: '20px' }}>
                            <ul style={{ display: "flex" }}>

                                <li class="pr-2"><label>Name</label>
                                    <select class="form-control mr-1 mb-1" name="name" onChange={handleChange}>
                                        <option value="">Select Name</option>
                                        <option value="Post">Post</option>
                                        <option value="Story">Story</option>
                                    </select>
                                </li>
                                <li class="pr-2"><label>Category</label>
                                    <select class="form-control mr-1 mb-1" name="category" onChange={handleChange}>
                                        <option value="">Select Category</option>
                                        <option value="diy_post">diy_post</option>
                                        <option value="diy_story">diy_story</option>
                                    </select>
                                </li>
                                <li class="pr-2"><label>Paid</label>
                                    <select class="form-control mr-1 mb-1" name="paid" onChange={handleChange}>
                                        <option value="">Select Type</option>
                                        <option value="true">true</option>
                                        <option value="false">false</option>
                                    </select>
                                </li>
                                <li class="pr-2"><label>Status</label>
                                    <select class="form-control mr-1 mb-1" name="status" onChange={handleChange}>
                                        <option value="">Select Status</option>
                                        <option value="1">Active</option>
                                        <option value="0">In Active</option>
                                    </select>
                                </li>
                            </ul>

                            <ul style={{ display: "flex" }}>
                                <li className='pt-2'><input class="form-control pr-1" type="file" onChange={handleImageChange} /></li>
                                {!isUploading && (
                                    <li className='pt-2'>
                                        <button class="btn btn-warning mr-4" type="submit">
                                            {isEditing ? 'Update' : 'Add'} Card
                                        </button>
                                    </li>
                                )}
                            </ul>
                            {formData.image_url && (
                                <img
                                    src={formData.image_url}
                                    alt="Preview"
                                    style={{ width: '100px', display: 'block', marginTop: '10px' }}
                                />
                            )}


                        </form>
                    </div>
                    <div className="card">
                        <div>
                            <div className="table-responsive fix-width scroll-inner">
                                <table className="table table-bordered table-hover">
                                    <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                                        <tr style={{ textAlign: "left" }}>


                                            <th className="col ps-2">Image</th>
                                            <th className="col ps-2">Name</th>
                                            <th className="col ps-2">Category</th>
                                            <th className="col ps-2">Paid</th>
                                            <th className="col ps-2">Status</th>
                                            <th className="col ps-2">Created Date</th>
                                            {/* <th className="col ps-2">Actions</th> */}
                                        </tr>
                                    </thead>
                                    <tbody style={{ textAlign: "left" }}>
                                        {cards.map(card => (
                                            <tr key={card.id}>
                                                <td>
                                                    <div className="d-flex px-2 py-1">
                                                        <div style={{ width: "7rem", marginRight: "1px" }}>
                                                            <img
                                                                src={card.image_url}
                                                                className="me-3"
                                                                style={{ height: "6rem" }}
                                                                alt={card.image_url}
                                                            />
                                                        </div>

                                                    </div>
                                                </td>
                                                <td className="align-middle text-center text-sm">
                                                    <span className="text-xs font-weight-bold mb-0">{card.name}</span>
                                                </td>
                                                <td className="align-middle text-center text-sm">
                                                    <span className="text-xs font-weight-bold mb-0">{card.category}</span>
                                                </td>
                                                <td className="align-middle text-center text-sm">
                                                    <span className="text-xs font-weight-bold mb-0">{card.paid == true ? "True" : "False"}</span>
                                                </td>

                                                <td className="align-middle text-center text-sm">
                                                    <span className="text-xs font-weight-bold mb-0">{card.status == 1 ? "Active" : "In-Active"}</span>
                                                </td>
                                                <td className="align-middle text-center text-sm">
                                                    <span className="text-xs font-weight-bold mb-0">{card.created_date?.toDate().toLocaleString()}</span>
                                                </td>
                                                {/* 
                                                <td className="align-middle text-center" onClick={() => handleDelete(card.id)}>
                                                    <span className="text-info text-xs font-weight-normal" style={{ cursor: "pointer" }}>
                                                        Delete
                                                    </span>
                                                </td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </main>




        </>
    );
}

export default CardManager;
